import 'emoji-mart/css/emoji-mart.css';

import { BoxProps } from '@chakra-ui/react';
import { Global, css } from '@emotion/react';
import { Picker, Emoji, PickerProps, EmojiData, EmojiProps } from 'emoji-mart';
import React from 'react';

import COLORS from '../../colors';

import getElevation, { ElevationSizes } from 'theme/elevations';

const EmojiStyles = (props: BoxProps): React.ReactElement => (
  <Global
    styles={css`
      .emoji-mart {
        font-family: 'Graphik', sans-serif;
        border: none;
        box-shadow: ${getElevation(props, ElevationSizes.xl)};
        border-radius: 8px;
      }

      .emoji-mart-category-label,
      .emoji-mart-search input {
        font-size: 14px;
      }

      .emoji-mart-title-label {
        font-size: 20px;
      }

      // COLOR OVERRIDES
      .emoji-mart-anchor.emoji-mart-anchor-selected {
        color: ${COLORS.blue.base} !important; // override inline styles
      }

      .emoji-mart-anchor-bar {
        background-color: ${COLORS.blue.base}!important; // override inline styles
      }

      .emoji-mart-anchor {
        color: ${COLORS.grey.lighter};
      }

      .emoji-mart-anchor-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      //DARK MODE COLOR OVERRIDES
      .emoji-mart-dark {
        background-color: ${COLORS.black.light};
        .emoji-mart-anchor {
          color: ${COLORS.grey.light};
        }

        .emoji-mart-category .emoji-mart-emoji:hover:before {
          background-color: ${COLORS.grey.base};
        }

        .emoji-mart-category-label span,
        .emoji-mart-search input {
          background-color: ${COLORS.black.light};
        }
      }

      .emoji-mart-search-icon {
        top: 0;
      }
    `}
  />
);

export default EmojiStyles;
export { Picker as EmojiPicker, Emoji, PickerProps, EmojiData, EmojiProps };
